import * as React from 'react';
import type { IListPageLayoutFilterTriggerProps } from './list-page-layout.types';
import { cn } from '@utils';

const NO_ACTIVE_FILTERS = 0;

export const ListPageLayoutFilterTrigger = React.forwardRef<HTMLDivElement, IListPageLayoutFilterTriggerProps>(
	({ children, activeCount = NO_ACTIVE_FILTERS, className }, ref) => (
		<div
			ref={ref}
			className={cn('relative inline-flex shrink-0', className)}
			data-testid="list-page-layout-filter-trigger"
		>
			{children}
			{/* Badge uses explicit px sizing: rem-based utilities collapse under consumer's 62.5% root font. */}
			{activeCount > NO_ACTIVE_FILTERS && (
				<span
					className="absolute -top-[5px] -right-[5px] flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-accent px-[4px] text-[10px] leading-none font-bold text-white"
					data-testid="list-page-layout-filter-trigger-badge"
				>
					{activeCount}
				</span>
			)}
		</div>
	)
);
ListPageLayoutFilterTrigger.displayName = 'ListPageLayoutFilterTrigger';
